import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IExtractorVendorMapping } from 'companySettings/types';
import { Button } from 'core/components';
import { Color } from 'theme/enums';

import { UpsertExtractorVendorMapping } from './UpsertExtractorVendorMapping';

interface IProps {
  extractorVendorMapping?: IExtractorVendorMapping;
  buttonElement?: ReactElement;
}

export const UpsertExtractorVendorMappingButton = ({
  extractorVendorMapping,
  buttonElement,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  // No grid plumbing: the save mutation invalidates the list query, so the rows come back from the
  // server and the client grid picks the saved mapping up on its own.
  const button = buttonElement ? (
    cloneElement(buttonElement, { onClick: () => setIsOpen(true) })
  ) : (
    <Button
      text={t('buttonLabelAddExtractorVendorMapping')}
      color={Color.SUCCESS}
      startDecorator={<Plus />}
      onClick={() => setIsOpen(true)}
    />
  );

  return (
    <>
      {button}

      {/* Rendered unconditionally on purpose: the form fields reset their auto-selected-contact ref
          in an effect on `isOpen`, which only works because this never unmounts between opens. */}
      <UpsertExtractorVendorMapping
        extractorVendorMapping={extractorVendorMapping}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
